import React, { ReactNode } from "react";
import TopBar from "./TopBar";
import ChatTopBar from "./ChatTopBar";
// import LeftSidebar from "./LeftSidebar";


interface ThemeLayoutProps {
    children: ReactNode;
}
const ThemeLayout = ({ children }: ThemeLayoutProps) => {
    return (
        <>
            {/* <TopBar /> */}
            <ChatTopBar setSelectedMode={() => {}} selectedMode={""}/>
            <div className="dash-board-main-wrapper">
               {/* <LeftSidebar /> */}
                {children}
            </div>
        </>
    );
};

export default ThemeLayout;


